import type { ThemeConfig } from 'antd';
import { colors } from './colors';

const FONT_FAMILY =
  'Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji';

const antdTheme: ThemeConfig = {
  token: {
    fontFamily: FONT_FAMILY,
    borderRadius: 8,
    boxShadow:
      '0px 3px 6px -4px rgba(83, 123, 213, 0.12), 0px 6px 16px 0px rgba(83, 123, 213, 0.08), 0px 9px 28px 8px rgba(83, 123, 213, 0.05)',
    boxShadowSecondary:
      '0px 6px 16px 0px rgba(83, 123, 213, 0.12), 0px 3px 6px -4px rgba(83, 123, 213, 0.08), 0px 9px 28px 8px rgba(83, 123, 213, 0.05)',
  },
  components: {
    Button: {
      borderRadius: 4,
      fontWeight: 500,
    },
    Checkbox: {
      borderRadiusSM: 2,
      borderRadiusXS: 2,
      borderRadiusLG: 2,
    },
    Input: {
      borderRadius: 4,
      controlHeight: 35,
      controlHeightLG: 40,
      controlHeightSM: 30,
      paddingInline: 12,
    },
    InputNumber: {
      borderRadius: 4,
    },
    Select: {
      borderRadius: 4,
      // Keep in sync with height in src/components/uielements/styles/select.style.js (AntSelect)
      // controlHeight drives antd internal layout (placeholder position, line-height, padding)
      // while AntSelect sets the actual outer height — a mismatch breaks placeholder alignment
      controlHeight: 40,
      optionHeight: 32,
    },

    Modal: {
      borderRadiusLG: 8,
      titleFontSize: 20,
      fontWeightStrong: 500,
    },

    Dropdown: {
      borderRadiusLG: 8,
    },
    // Menu uses a custom component (src/components/uielements/customMenu).
    // Overrides here will not work — style the custom component directly instead.
  },
};

export default antdTheme;
